import CKEditor from "ckeditor4-react";
import { sv } from "date-fns/esm/locale";
import { Box, Button, CheckBox, Form, FormField, TextInput } from "grommet";
import { Save } from "grommet-icons";
import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useCreateMeetingMutation } from "../generated/graphql";
registerLocale("sv", sv);

interface Props {
  showModal: boolean;
  setShowModal(s: boolean): void;
}

interface CustomInputProps {
  value?: string;
  onClick?: () => any;
}

export const CreateMeeting: React.FC<Props> = ({ setShowModal }) => {
  const [privilegedChecked, setPrivilegedChecked] = useState(false);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");
  const [date, setDate] = useState(new Date());

  const [createMeeting] = useCreateMeetingMutation({
    refetchQueries: [`Meetings`]
  });
  // const [createArticle] = useCreateArticleMutation({
  //   refetchQueries: ["articles"]
  // });

  return (
    <Box pad="large">
      <h2>Skapa aktivitet</h2>
      <Form>
        <FormField label="Dag &amp; Tid">
          <DatePicker
            placeholderText="Välj datum och tid"
            selected={date}
            onChange={date => {
              setDate(date);
              console.log(date);
            }}
            showTimeSelect
            locale="sv"
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="Tid"
            dateFormat="MMMM d, yyyy HH:mm"
          />
        </FormField>
        <FormField label="Plats">
          <TextInput
            placeholder="skriv här"
            onChange={({ target }) => {
              setLocation(target.value);
            }}
          />
        </FormField>
        <FormField label="Titel">
          <TextInput
            placeholder="skriv här"
            onChange={({ target }) => {
              setTitle(target.value);
            }}
          />
        </FormField>
        <FormField label="Beskrivning (valfritt)">
          <CKEditor
            onBeforeLoad={CKEDITOR => (CKEDITOR.disableAutoInline = true)}
            data={content}
            onChange={evt => {
              if (evt.editor) {
                const serialisedContent = btoa(evt.editor.getData());
                localStorage.setItem(
                  "serializedHtmlContent",
                  serialisedContent
                );
                setContent(evt.editor.getData());
              }
            }}
            config={{
              height: "100px",
              language: "sv",
              toolbar: [
                ["Bold", "Italic", "Strike", "-", "RemoveFormat"],
                ["Link", "Unlink"],
                ["Copy", "Cut", "Paste"]
              ]
            }}
            // type="inline"
            style={{
              padding: 10,
              minHeight: "100px"
            }}
          />
        </FormField>
        <FormField label="Länk (valfritt)">
          <TextInput
            placeholder="inkl http/https"
            onChange={({ target }) => {
              setUrl(target.value);
            }}
          />
        </FormField>

        <CheckBox
          checked={privilegedChecked}
          label="Visa endast för priviligerade användare"
          onChange={() => setPrivilegedChecked(!privilegedChecked)}
        />
        <hr />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            primary
            icon={<Save />}
            label="Spara"
            onClick={async () => {
              try {
                createMeeting({
                  variables: {
                    location,
                    title,
                    content,
                    url,
                    date: date.toString()
                  }
                });
                // createFolder({
                //   variables: {
                //     companyId,
                //     name,
                //     isPrivileged: privilegedChecked
                //   }
                // });
                // createArticle({
                //   variables: {
                //     title: title,
                //     content: htmlContent,
                //     sms: smsChecked,
                //     mail: mailChecked,
                //     isPrivileged: privilegedChecked
                //   }
                // });
                setShowModal(false);
              } catch (error) {
                console.log(error);
              }
            }}
          />
          <Button label="Stäng" onClick={() => setShowModal(false)} />
        </div>
      </Form>
    </Box>
  );
};
